import React from "react";
import { Card, Heading } from "uikit/components";
import { arrayOf, exact, number, shape, string } from "prop-types";
import cx from "classnames";
import styles from "./RegionLoadingSummaryCard.module.styl";
import { percentageLevels } from "utils/indicator/indicatorSettings";
import { regionIds } from "utils/reports/RegionIds";
import IconTooltip from "uikit/components/IconTooltip/IconTooltip";
import Chart from "react-apexcharts";
import { chartOptions } from "utils/chart/chartOptions";

export default function RegionLoadingSummaryCard({ regionData, regionId }) {
    const indicatorStyle = percentageLevels.indicatorColor(regionData.loading);
    const options = chartOptions(indicatorStyle, "24px");
    const series = [regionData.loading];

    return (
        <Card
            borderRadius={"giant"}
            padding={"none"}
            className={cx(styles.form, percentageLevels.indicatorColor(regionData.loading).style)}
        >
            <div className={styles.content} data-test-name="region_summary">
                <div>
                    <div className={styles.heading}>
                        <Heading size={"h2"}>Сводный показатель по спортивным объектам</Heading>
                        <div className={styles.icon}>
                            <IconTooltip trigger={"hover"}>
                                <div className={styles.infoPanel}>
                                    Сводный показатель загруженности спортивных объектов региона
                                    рассчитывается как среднее значение по загруженности районов,
                                    входящих в его состав.
                                </div>
                            </IconTooltip>
                        </div>
                    </div>
                    <div className={styles.wrapper}>
                        <div>
                            <div className={styles.indicator}>
                                <div className={styles.indicators}>
                                    {regionData.sportObjectsCount}
                                </div>
                            </div>
                            <div className={styles.descriptionTitle}>
                                спортивных объектов находятся в регионе
                            </div>
                        </div>
                        {regionId === regionIds.UdmurtiaRegionId && ( //TODO SPORT-8078 закостылили статичные данные для демо региона Удмуртия, нужно убрать после демо
                            <div>
                                <div className={styles.indicator}>
                                    <div className={styles.numerator}>{4151}</div>
                                </div>
                                <div
                                    className={cx(
                                        styles.descriptionTitle,
                                        styles.descriptionTitleMarginLeft,
                                    )}
                                >
                                    объектов спортивной инфраструктуры (соответствует форме N 1-ФК)
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.chart} data-test-name="region-loading-summary-chart">
                    <Chart options={options} series={series} type="radialBar" width="185" />
                    <div
                        className={cx(
                            styles.percentageText,
                            percentageLevels.indicatorColor(regionData.loading).textStyle,
                        )}
                    >
                        {regionData.loading >= percentageLevels.normal
                            ? regionData.loading >= percentageLevels.good
                                ? "высокий уровень загруженности объектов"
                                : "средний уровень загруженности объектов"
                            : "низкий уровень загруженности объектов"}
                    </div>
                </div>
            </div>
        </Card>
    );
}

RegionLoadingSummaryCard.propTypes = {
    regionId: number.isRequired,
    regionData: exact({
        reportDates: shape({
            start: string.isRequired,
            end: string.isRequired,
        }).isRequired,
        municipalityName: string.isRequired,
        regionData: arrayOf(
            shape({
                municipalityId: number,
                name: string,
                loading: number,
                sportObjectsCount: number,
            }),
        ),
    }),
};
